import { Box, Flex, FormLabel, Text } from '@chakra-ui/react';
import { Field, FormikHandlers } from 'formik';
import Button from '~/components/Button';
import { IconBox } from '~/components/IconBox';
import {
  SOCIAL_PLATFORMS,
  SOCIAL_PLATFORMS_CONNECTION_STATUS,
  SOCIAL_PLATFORMS_NAMES,
} from '~/constants';

import { SOCIAL_PLATFORM_CONNECTION } from '../NameAndPlatform.constants';
import { NameAndPlatformValues } from '../NameAndPlatform.types';

interface Props {
  onBlur: FormikHandlers['handleBlur'];
  onChange: FormikHandlers['handleChange'];
  values: NameAndPlatformValues;
}

export const NameAndPlatformPlatforms: React.FC<Props> = ({
  onBlur,
  onChange,
  values,
}) => (
  <Flex
    justifyContent="flex-start"
    alignItems="flex-start"
    marginX={{ base: -1, md: -4 }}
  >
    {Object.entries(SOCIAL_PLATFORM_CONNECTION).map(
      ([platform, { icon: Icon, component: PlatformConnect }]) => (
        <PlatformConnect key={`checkbox-${platform}`} onSuccess={() => null}>
          {({ disclosure, status }) => {
            const isChecked = values.platforms?.includes(
              platform as SOCIAL_PLATFORMS,
            );
            const isConnected =
              status === SOCIAL_PLATFORMS_CONNECTION_STATUS.connected ||
              status === SOCIAL_PLATFORMS_CONNECTION_STATUS.connectionExpired;
            const isDisconnectedOrExpired =
              status === SOCIAL_PLATFORMS_CONNECTION_STATUS.disconnected ||
              status === SOCIAL_PLATFORMS_CONNECTION_STATUS.connectionExpired;

            return (
              <Box>
                <FormLabel
                  backgroundColor={isConnected ? 'white' : 'primary.50'}
                  borderColor={isChecked ? 'primary.500' : 'primary.50'}
                  borderRadius="md"
                  borderStyle="solid"
                  borderWidth={1}
                  boxSizing="content-box"
                  cursor={isConnected ? 'pointer' : 'none'}
                  display="block"
                  htmlFor={`checkbox-${platform}`}
                  id={`label-${platform}`}
                  margin={0}
                  marginX={{ base: 1, md: 4 }}
                  minWidth="60px"
                  paddingX={4}
                  paddingY={3}
                  pointerEvents={isConnected ? 'all' : 'none'}
                  textAlign="center"
                >
                  <IconBox
                    padding={1}
                    backgroundColor={
                      isConnected ? 'primary.500' : 'primary.200'
                    }
                    icon={<Icon boxSize={4} color="white" />}
                  />
                  <Text
                    color={isConnected ? 'primary.500' : 'primary.200'}
                    fontSize="sm"
                    fontWeight={400}
                  >
                    {SOCIAL_PLATFORMS_NAMES[platform as SOCIAL_PLATFORMS]}
                  </Text>

                  <Box
                    as={Field}
                    disabled={isConnected ? undefined : 'disabled'}
                    display="none"
                    id={`checkbox-${platform}`}
                    name="platforms"
                    onBlur={onBlur}
                    onChange={onChange}
                    type="checkbox"
                    value={platform}
                  />
                </FormLabel>

                {isDisconnectedOrExpired && (
                  <Button
                    display="block"
                    marginX="auto"
                    paddingTop={3}
                    color={isConnected ? 'error.500' : 'secondary.400'}
                    isLoading={disclosure.isOpen}
                    onClick={disclosure.onOpen}
                    variant="link"
                    rounded="none"
                  >
                    {status === SOCIAL_PLATFORMS_CONNECTION_STATUS.disconnected
                      ? 'Connect'
                      : 'Reconnect'}
                  </Button>
                )}
              </Box>
            );
          }}
        </PlatformConnect>
      ),
    )}
  </Flex>
);
